// import ky from 'ky';

// https://github.com/sindresorhus/ky

import {
  generateBrowserId,
  generateChecksum,
  getAccount,
  storeAccount,
  getRegions,
  storeRegions,
  convertJsonToParams,
} from './sharedUtils';

let SHOP_API_KEY = null;
const cachedLocationSuggestions = {};
const cachedMeasureClicks = {};
const cachedMeasureSearches = {};

let API_DOMAIN = process.env.REACT_APP_REST_API_LOCATION || 'http://localhost:3000';

const getCurrentUrl = ()=> {
  return encodeURIComponent(window.location.href);
}

const getHeaders = (apiKey) => {
  return {
    'Content-Type': 'application/json',
    'x-api-key': generateBrowserId(apiKey),
    'x-checksum': generateChecksum(apiKey)
  }
}

export const setupApi = ({apiKey, apiDomain=null})=> {
  SHOP_API_KEY = apiKey;
  if(!!apiDomain) {
    API_DOMAIN = apiDomain;
  }
}

export const fetchAccount = async (accountId, api_key=null, isPreviewing = false)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  const existingAccount = getAccount(accountId);
  if(!isPreviewing && existingAccount) {
    return new Promise((resolve, reject)=>{
      return resolve({...existingAccount});
    })
  }
  
  const response = await fetch(`${API_DOMAIN}/api/accounts/${accountId}?url=${getCurrentUrl()}`, {
    method: 'GET',
    headers: getHeaders(apiKey),
  })

  const responseJSON = await response.json();
  storeAccount(accountId, responseJSON, 10 * 60);

  return new Promise((resolve, reject)=>{
    return resolve(responseJSON);
  })
}

export const fetchRegions = async (accountId, api_key=null, isPreviewing = false)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  const existingRegions = getRegions(accountId);
  if(!isPreviewing && existingRegions) {
    return new Promise((resolve, reject)=>{
      return resolve({...existingRegions});
    })
  }
  
  const response = await fetch(`${API_DOMAIN}/api/accounts/${accountId}/regions?url=${getCurrentUrl()}&ignorecheck=true`, {
    method: 'GET',
    headers: getHeaders(apiKey),
  })

  const responseJSON = await response.json();
  storeRegions(accountId, responseJSON, 10 * 60);

  return new Promise((resolve, reject)=>{
    return resolve(responseJSON);
  })
}

// window.getRegions = getRegions;
// window.fetchRegions = fetchRegions;

export const fetchGeoIp = async (accountId, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  const response = await fetch(`${API_DOMAIN}/api/accounts/${accountId}/geoip?url=${getCurrentUrl()}&ignorecheck=true`, {
    method: 'GET',
    headers: getHeaders(apiKey),
  })

  const responseJSON = await response.json();

  return new Promise((resolve, reject)=>{
    return resolve(responseJSON);
  })
}

export const lookupLocations = async (accountId, params, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  const query = convertJsonToParams({
    ...params,
    url: getCurrentUrl(),
    ignorecheck: true
  })

  const response = await fetch(`${API_DOMAIN}/api/accounts/${accountId}/nearby?${query}`, {
    method: 'GET',
    headers: getHeaders(apiKey),
  })

  const responseJSON = await response.json();

  return new Promise((resolve, reject)=>{
    return resolve(responseJSON);
  })
}

export const suggestLocations = async (accountId, params, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  const existingData = cachedLocationSuggestions[params.query];

  if (existingData) {
    return new Promise((resolve, reject)=>{
      return resolve(existingData);
    })    
  }

  const query = convertJsonToParams({
    ...params,
    url: getCurrentUrl(),
    ignorecheck: true
  })

  const response = await fetch(`${API_DOMAIN}/api/accounts/${accountId}/suggest?${query}`, {
    method: 'GET',
    headers: getHeaders(apiKey),
  })

  const responseJSON = await response.json();
  cachedLocationSuggestions[params.query] = {...responseJSON}
  return new Promise((resolve, reject)=>{
    return resolve(responseJSON);
  })
}

// =============================
// analytics
// =============================
export const submitLead = async (accountId, data, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;

  const response = await fetch(`${API_DOMAIN}/api/accounts/${accountId}/metrics/lead?&ignorecheck=true`, {
    method: 'POST',
    headers: getHeaders(apiKey),
    body: JSON.stringify({lead: data})
  })

  const responseJSON = await response.json();

  return new Promise((resolve, reject)=>{
    return resolve(responseJSON);
  })
}

const measureClick = async (accountId, data, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  if (cachedMeasureClicks[data.location_id]) return false;
  cachedMeasureClicks[data.location_id] = 1;
  await fetch(`${API_DOMAIN}/api/accounts/${accountId}/metrics/clicking?&ignorecheck=true`, {
    method: 'POST',
    headers: getHeaders(apiKey),
    body: JSON.stringify({clicking: data})
  })
}

const measureView = async (accountId, data, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;

  await fetch(`${API_DOMAIN}/api/accounts/${accountId}/metrics/viewing?&ignorecheck=true`, {
    method: 'POST',
    headers: getHeaders(apiKey),
    body: JSON.stringify({viewing: data})
  })
}

const measureSearch = async (accountId, data, api_key=null)=>{
  const apiKey = api_key || accountId || SHOP_API_KEY;
  if (cachedMeasureSearches[data.place_id]) return false;
  cachedMeasureSearches[data.place_id] = 1;

  await fetch(`${API_DOMAIN}/api/accounts/${accountId}/metrics/searching?&ignorecheck=true`, {
    method: 'POST',
    headers: getHeaders(apiKey),
    body: JSON.stringify({searching: data})
  })
}

export const CBAnalytics = {
  view: measureView,
  click: measureClick,
  search: measureSearch
}
